import { render, staticRenderFns } from "./Pinnedentity.vue?vue&type=template&id=c8697134&scoped=true"
import script from "./Pinnedentity.vue?vue&type=script&lang=js"
export * from "./Pinnedentity.vue?vue&type=script&lang=js"
import style0 from "./Pinnedentity.vue?vue&type=style&index=0&id=c8697134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8697134",
  null
  
)

export default component.exports